import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { CommentsFilterBar } from "~/components/AssetModalV2/InfoPanel/Comments/components/CommentsFilterBar";
import { CommentsVersionsDropdown } from "~/components/AssetModalV2/InfoPanel/Comments/components/CommentsVersionsDropdown";
import { PublicComments } from "~/components/AssetModalV2/InfoPanel/Comments/PublicCommentsPanel";
import { InfoPanel } from "~/components/AssetModalV2/InfoPanel/components/InfoPanel";
import { PublicCustomFieldsCollapsibleSection } from "~/components/AssetModalV2/InfoPanel/CustomFields/PublicCustomFieldsCollapsibleSection";
import { PublicDescriptionAndTagsCollapsibleSection } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/PublicDescriptionAndTagsCollapsibleSection";
import { PublicExifCollapsibleSection } from "~/components/AssetModalV2/InfoPanel/Exif/PublicExifCollapsibleSection";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { canSeeAssetCustomFields, canSeeAssetVersions, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicInfoPanel = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const canViewVersions = canSeeAssetVersions(permissions);
    const canEdit = false;
    const canViewCustomFields = canSeeAssetCustomFields(permissions);
    const canViewComments = canViewAssetDiscussions(permissions);
    const canViewAssetVersions = canSeeAssetVersions(permissions);
    const canDiscuss = canViewAssetDiscussions(permissions);
    const contentHeader = useMemo(()=>canDiscuss && canViewAssetVersions ? /*#__PURE__*/ _jsx(CommentsFilterBar, {
            children: /*#__PURE__*/ _jsx(CommentsVersionsDropdown, {})
        }) : undefined, [
        canDiscuss,
        canViewAssetVersions
    ]);
    return /*#__PURE__*/ _jsx(InfoPanel, {
        canEdit: canEdit,
        canViewVersions: canViewVersions,
        canViewComments: canViewComments,
        infoView: /*#__PURE__*/ _jsxs("div", {
            children: [
                canViewCustomFields && /*#__PURE__*/ _jsx(PublicCustomFieldsCollapsibleSection, {}),
                /*#__PURE__*/ _jsx(PublicDescriptionAndTagsCollapsibleSection, {}),
                /*#__PURE__*/ _jsx(PublicExifCollapsibleSection, {})
            ]
        }),
        commentsView: /*#__PURE__*/ _jsxs("div", {
            className: "flex h-full flex-col",
            children: [
                contentHeader,
                /*#__PURE__*/ _jsx("div", {
                    className: "min-h-0 flex-1",
                    children: /*#__PURE__*/ _jsx(PublicComments, {})
                })
            ]
        })
    });
});
PublicInfoPanel.displayName = "PublicInfoPanel";
